<template>
  <div class="flex flex-col expedited-button">
    <h3 class="option">
      Expedited
    </h3>
    <p>Choose this option to speed up the shipment.<br>Note that some products may have restrictions.</p>
    <div class="flex flex-row expedited-switch">
      <el-switch
          v-model="isExpedited"
          :width="30"
          @change="toggleExpedited" />
      <span
          v-if="isExpedited"
          class="on">On
      </span>
      <span
          v-else
          class="off">Off
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpeditedFormButton",
  props: {
    expedited: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isExpedited: this.expedited,
    };
  },
  methods: {
    toggleExpedited(value) {
      this.$emit("update:expedited", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.expedited-button {
  p {
    font-size: smaller;
  }
  h3.option {
    font-variant: all-small-caps;
    font-size: large;
    color: #6e6e6e;
    margin: 0;
  }
  .expedited-switch {
    span {
      font-size: 15px;
      display: inline-block;
      font-weight: bold;
      margin-left: 0.4rem;
      margin-top: 0.1rem;
      &.off {
        color: $--color-text-secondary;
      }
      &.on {
        color: $--color-primary;
      }
    }
  }
}
</style>
